import {texture, json} from "p3";
import { Emitter } from "pixi-particles";
import definitions from "../../definitions";
import common from "../../common";
import Actor from "./Actor";
import settings from "../../settings";

export default class ActorCampfire extends Actor {
    constructor() {
        super(definitions.ACTOR_ID.CAMPFIRE);

        this.collisionRadius = 24;
        this.collisionOffsetX = -4;
        this.collisionOffsetY = -34;
        
        this._fx = null;
        this._campfireTexture = null;

        this.interactable = settings.PHASE > 1;
        this.interactionRadius = 160;
    }

    init() {
        super.init();

        this.signals.interact.add(this._toggleOnOff, this);

        this._setCampfireTexture();

        this.addViewWithTexture(this._campfireTexture);

        this._emitFx();
    }

    update() {
        this._fx && this._fx.update(window.dt);

        super.update();
    }

    _setCampfireTexture() {
        const activeLocation = common.saveData.activeSlot.player.lastLocation;
        const locationSuffix = activeLocation[0] + activeLocation.substring(activeLocation.indexOf('_') + 1)[0];
        this._campfireTexture = texture(locationSuffix.concat("_d_campfire_00"));
    }

    _toggleOnOff() {
        this._fx.emit = !this._fx.emit; 
    }

    _emitFx() {
        this._fx = this._createFx();
    }

    _createFx() {
        const emitter = new Emitter(this, [texture("smoke_particle_fx_00"), texture("smoke_particle_fx_01")], json("fx_smoke_particle_smoulder"));
        emitter.autoUpdate = false;
        emitter.updateSpawnPos(0, -40);
        return emitter;
    }

    onViewAdded() {
        super.onViewAdded();

        this._view.anchor.set(0.5, 1);
    }

    onInteractionRangeEnter() {
        super.onInteractionRangeEnter();
    }

    onInteractionRangeExit() {
        super.onInteractionRangeExit();
    }

    onInteractWith(actor) {
        super.onInteractWith(actor);
    }
}